import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './../../../../assets/icons/person.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-719dd85e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info-content" }
const _hoisted_2 = ["title"]
const _hoisted_3 = { class: "main-info" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"48px"},
  alt: "",
  src: _imports_0
}, null, -1))
const _hoisted_5 = { class: "right-col" }
const _hoisted_6 = {
  class: "cm-align-center cm-ui-mt15 cm-ui-mb5",
  style: {"gap":"3px"}
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: "admin-type"
}
const _hoisted_10 = { class: "operate-list" }
const _hoisted_11 = { class: "operate-item-main" }
const _hoisted_12 = { class: "operate-item-main" }
const _hoisted_13 = { class: "operate-item-main" }
const _hoisted_14 = { class: "operate-item-main" }
const _hoisted_15 = { class: "operate-list" }
const _hoisted_16 = { class: "operate-item-main" }
const _hoisted_17 = { class: "info-thumb cm-ui-ml5" }
const _hoisted_18 = { style: {"font-size":"12px"} }
const _hoisted_19 = {
  class: "cm-ui-dialog-title",
  style: {"padding-top":"25px"}
}

import { onMounted, onUnmounted, reactive, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { ElMessageBox } from 'element-plus'
import { User, UserInfo } from '@/services/user'
import { Team, TeamInfo } from '@/services/team'

import TeamInfoEdit from './_components/team-info-edit/team-info-edit.vue'
import UserInfoEdit from './_components/user-info-edit/user-info-edit.vue'
import TeamManage from './_components/team-manage/team-manage.vue'
import CreateTeam from '@/views/_components/create-team/create-team.vue'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { DashboardService } from '../../dashboard.service'
import { Reporter } from '@/services/reporter'
import { useRoute } from 'vue-router'
import Cookies from 'js-cookie'
import { IS_PRIVATE } from '@/common/const/env'
import UpdatePassword from '@/views/dashboard/_components/update-password/update-password.vue'
import { useRolePermStore } from '@/services/role-perm.service'
import { toLoginPage } from '@/services/login.service'
import { isEditableShortcutTarget, isPlainShiftChord } from '@/utils/keyboard-shortcut'
import KbdShiftLetter from '@/components/kbd-shift-letter/kbd-shift-letter.vue'
import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'

export default /*#__PURE__*/_defineComponent({
  __name: 'central-control',
  setup(__props) {

const { t } = useI18n()
const rolePermStore = useRolePermStore()
const injector = useReflectiveInjector([])
const user = injector.get(User)
const dashboardServer = injector.get(DashboardService)
const userInfo = reactive<Partial<UserInfo>>({})

const team = injector.get(Team)
const teamInfo = reactive<Partial<TeamInfo>>(JSON.parse(Cookies.get('currentTeam')))

const dialogUserInfoVisible = ref<boolean>(false)
const dialogTeamManageVisible = ref<boolean>(false)
const dialogTeamInfoEditVisible = ref<boolean>(false)
const dialogCreateTeamVisible = ref<boolean>(false)
const updatePasswordVisible = ref<boolean>(false)

const route = useRoute()
const reporter = injector.get(Reporter)

user.userInfo.subscribe(info => {
  Object.assign(userInfo, info)
})

team.currentTeam.subscribe(info => {
  Object.assign(teamInfo, info)
})

function handlerShowDialogUserEdit() {
  dialogUserInfoVisible.value = true
}

function handlerShowTeamManage() {
  dialogTeamManageVisible.value = true
}

function handlerHideTeamManage() {
  dialogTeamManageVisible.value = false
}

function handlerShowCreateTeam() {
  dialogTeamManageVisible.value = false
  dialogCreateTeamVisible.value = true

  reporter.pvReporter({
    show_from: route.query.show_from as string,
    page_pos: 'create_team_popup',
  })
}

function handleHideCreateTeam() {
  dialogCreateTeamVisible.value = false
}

function handleCreatedTeam(team: { name: string, num: number }) {
  reporter.createTeamReporter({
    show_from: route.query.show_from as string,
    page_pos: 'create_team_popup',
    team_name: team.name,
    team_num: String(team.num),
  })
  dashboardServer.reload()
}

function handlerShowDialogTeamEdit() {
  dialogTeamInfoEditVisible.value = true
}

function handlerLogoutConfirm() {
  ElMessageBox.confirm(
    t('centralControl.logoutConfirmMessage',{nickname: userInfo.nick||userInfo.user_name}),
    t('centralControl.logoutConfirmTitle'),
    {
      confirmButtonText: t('common.confirm'),
      cancelButtonText: t('common.cancel')
    }
  ).then(() => {
    toLoginPage(true)
  }).catch(() => { })
}

function handlerLogout() {
  handlerLogoutConfirm()
}

function handleCentralControlKeydown(e: KeyboardEvent) {
  if (!isPlainShiftChord(e)) return
  if (isEditableShortcutTarget(e.target)) return

  const raw = e.key
  if (raw.length !== 1) return
  const k = raw.toLowerCase()

  let handled = false
  if (k === 's' && !IS_PRIVATE) {
    handlerShowTeamManage()
    handled = true
  } else if (k === 'p' && !IS_PRIVATE) {
    handlerShowDialogUserEdit()
    handled = true
  } else if (k === 'g' && rolePermStore.cmRolePermMapFe?.team_update) {
    handlerShowDialogTeamEdit()
    handled = true
  } else if (k === 'w' && IS_PRIVATE) {
    updatePasswordVisible.value = true
    handled = true
  } else if (k === 'q') {
    handlerLogoutConfirm()
    handled = true
  }

  if (handled) {
    e.preventDefault()
  }
}

onMounted(() => {
  window.addEventListener('keydown', handleCentralControlKeydown, true)
})

onUnmounted(() => {
  window.removeEventListener('keydown', handleCentralControlKeydown, true)
})

return (_ctx: any,_cache: any) => {
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_role_perm = _resolveDirective("role-perm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_popover, {
      width: "auto",
      trigger: "click",
      "hide-after": 10,
      "show-arrow": false,
      offset: 4,
      "popper-class": "central-control-wrap-popover el-card"
    }, {
      reference: _withCtx(() => [
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_el_avatar, {
            src: "./../../../../assets/icons/person.png",
            size: 30,
            style: {"background-color":"var(--cm-color-primary)","display":"flex","justify-content":"center"},
            title: teamInfo.name
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_18, _toDisplayString(teamInfo.name), 1)
            ]),
            _: 1
          }, 8, ["title"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "team-name",
            title: teamInfo.name
          }, _toDisplayString(teamInfo.name), 9, _hoisted_2),
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", null, _toDisplayString(userInfo.nick), 1),
                (teamInfo.role_name)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, "·"))
                  : _createCommentVNode("", true),
                (teamInfo.role_name)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(teamInfo.role_name), 1))
                  : _createCommentVNode("", true)
              ]),
              (userInfo.email)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(userInfo.email), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            (!_unref(IS_PRIVATE) && !_unref(IS_JP_ONLY_BUILD))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "operate-item",
                  onClick: handlerShowTeamManage
                }, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_CmSvgIcon, {
                      name: "views/dashboard/_components/central-control/_images/change-team",
                      class: "normal",
                      monochrome: ""
                    }),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('centralControl.switchTeam')), 1)
                  ]),
                  _createVNode(KbdShiftLetter, {
                    class: "operate-item-kbd",
                    letter: "S"
                  })
                ]))
              : _createCommentVNode("", true),
            (!_unref(IS_PRIVATE))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "operate-item",
                  onClick: handlerShowDialogUserEdit
                }, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_CmSvgIcon, {
                      name: "views/dashboard/_components/central-control/_images/user-info",
                      class: "normal",
                      monochrome: ""
                    }),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('centralControl.personalInfo')), 1)
                  ]),
                  _createVNode(KbdShiftLetter, {
                    class: "operate-item-kbd",
                    letter: "P"
                  })
                ]))
              : _createCommentVNode("", true),
            _withDirectives((_openBlock(), _createElementBlock("div", {
              class: "operate-item",
              onClick: handlerShowDialogTeamEdit
            }, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_CmSvgIcon, {
                  name: "views/dashboard/_components/central-control/_images/team-info",
                  class: "normal",
                  monochrome: ""
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('centralControl.teamInfo')), 1)
              ]),
              _createVNode(KbdShiftLetter, {
                class: "operate-item-kbd",
                letter: "G"
              })
            ])), [
              [_directive_role_perm, _unref(rolePermStore)?.cmRolePermMapFe?.team_update]
            ]),
            (_unref(IS_PRIVATE))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "operate-item",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (updatePasswordVisible.value = true))
                }, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_CmSvgIcon, {
                      name: "views/dashboard/_components/central-control/_images/password",
                      class: "normal",
                      monochrome: ""
                    }),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('centralControl.changePassword')), 1)
                  ]),
                  _createVNode(KbdShiftLetter, {
                    class: "operate-item-kbd",
                    letter: "W"
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", {
              class: "operate-item operate-logout",
              onClick: handlerLogout
            }, [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_CmSvgIcon, {
                  name: "views/dashboard/_components/central-control/_images/logout",
                  class: "normal logout",
                  monochrome: ""
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('centralControl.logout')), 1)
              ]),
              _createVNode(KbdShiftLetter, {
                class: "operate-item-kbd",
                letter: "Q"
              })
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(UpdatePassword, {
      modelValue: updatePasswordVisible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((updatePasswordVisible).value = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      "append-to-body": "",
      "z-index": 1000,
      title: ' ',
      modelValue: dialogTeamManageVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialogTeamManageVisible).value = $event)),
      width: 570,
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createVNode(TeamManage, {
          onClose: handlerHideTeamManage,
          onCreateTeam: handlerShowCreateTeam
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      "append-to-body": "",
      "z-index": 1000,
      title: ' ',
      modelValue: dialogUserInfoVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialogUserInfoVisible).value = $event)),
      width: 470,
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createVNode(UserInfoEdit)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      "append-to-body": "",
      "z-index": 1000,
      title: ' ',
      modelValue: dialogCreateTeamVisible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dialogCreateTeamVisible).value = $event)),
      width: 470,
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('centralControl.createTeam')), 1),
        _createVNode(CreateTeam, {
          onClose: handleHideCreateTeam,
          onCreated: handleCreatedTeam
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      "destroy-on-close": "",
      "append-to-body": "",
      title: ' ',
      modelValue: dialogTeamInfoEditVisible.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((dialogTeamInfoEditVisible).value = $event)),
      width: 470
    }, {
      default: _withCtx(() => [
        _createVNode(TeamInfoEdit, {
          onClose: _cache[5] || (_cache[5] = ($event: any) => (dialogTeamInfoEditVisible.value = false))
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})